import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function HeavenlyBody({ children, path, styles }) {
  return (
    <Link className={`home-planet ${styles.join(" ")}`} to={path}>
      {children}
    </Link>
  );
}

HeavenlyBody.propTypes = {
  path: PropTypes.string.isRequired,
  styles: PropTypes.array.isRequired,
  children: PropTypes.any.isRequired,
};
